import { Modal } from 'almanac-ui/Modal'
import { Radio, RadioGroup } from 'components/RadioGroup'
import { EmailValue } from 'components/ShareSheet/RecipientSelector/Types'
import { InviteToWorkspaceProps } from './Types'
import Styles from './ShareSheet.module.scss'
import { Header } from 'common/ShareSheetV2/Header/Header'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { UserProfile, Users } from 'blaze-ui/icons'
import { Plane } from 'blaze-ui/icons/24'
import cx from 'classnames'
import { Button } from 'blaze-ui/Button'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { ShareSheetScreen, useShareSheetContext } from 'common/ShareSheetV2/ShareSheetV2'
import useShareSheetV2 from 'hooks/useShareSheetV2'

export const RecipientRow = ({ recipient }: { recipient: EmailValue }) => {
  return (
    <div className={Styles.guestRow}>
      <UserProfile />
      <Text variant="smallList" color="var(--dark-80)">
        {recipient.value}
      </Text>
    </div>
  )
}

export const InviteToWorkspace = ({
  onSubmit,
  goBack,
  isSubmitting,
  inviteToWorkspace,
  setInviteToWorkspace,
  newRecipients,
}: InviteToWorkspaceProps) => {
  const { setScreen, file } = useShareSheetContext()
  const { setShareSheet } = useShareSheetV2(file)
  return (
    <>
      <Header onBack={goBack}>
        <Heading level={3}>Invite new members to your workspace</Heading>
      </Header>
      <div className={Styles.content}>
        <Heading level={5}>New Users</Heading>
        <div className={Styles.guestsContainer}>
          {newRecipients.map((recipient, idx) => (
            <RecipientRow key={`recipient-${idx}`} recipient={recipient} />
          ))}
        </div>
        <Heading level={5}>Choose their status?</Heading>
        <RadioGroup
          value={inviteToWorkspace.toString()}
          onChange={(invite: string) => {
            setInviteToWorkspace(invite === 'true')
          }}
          className={Styles.radioOptions}
          aria-label="Would you like to invite these users to your workspace?"
        >
          <div className={cx(Styles.radioOptionContainer, { [Styles.isSelected]: !inviteToWorkspace })}>
            <Radio value="false" aria-label="Invite as guest" className={Styles.radioOption}>
              <div className={Styles.option}>
                <div className={Styles.icon}>
                  <Plane />
                </div>
                <Heading level={5}>External guests </Heading>
                <Text variant="secondary" color="var(--dark-60)">
                  Guests will only have access to files explicitly shared with them.
                </Text>
              </div>
            </Radio>
          </div>
          <div className={cx(Styles.radioOptionContainer, { [Styles.isSelected]: inviteToWorkspace })}>
            <Radio value="true" aria-label="Invite to workspace" className={Styles.radioOption}>
              <div className={Styles.option}>
                <div className={Styles.icon}>
                  <Users />
                </div>
                <Heading level={5}>Part of your team </Heading>
                <Text variant="secondary" color="var(--dark-60)">
                  Add as members to your workspace for full access.
                </Text>
              </div>
            </Radio>
          </div>
        </RadioGroup>
        <ResponsiveDesign.Mobile>
          <Button size="lg" variant="primary" fullWidth onPress={onSubmit} isDisabled={isSubmitting}>
            Send Invite
          </Button>
        </ResponsiveDesign.Mobile>
      </div>

      <ResponsiveDesign.Desktop>
        <Modal.Footer>
          <Modal.FooterContent slot="left">
            <Button
              size="lg"
              variant="tertiary"
              onPress={() => {
                setShareSheet({ recipients: [], inviteMessage: '' })
                setScreen(ShareSheetScreen.Default)
              }}
              isDisabled={isSubmitting}
            >
              Cancel
            </Button>
          </Modal.FooterContent>
          <Modal.FooterContent slot="right">
            <Button size="lg" variant="primary" onPress={onSubmit} isDisabled={isSubmitting}>
              Send Invite
            </Button>
          </Modal.FooterContent>
        </Modal.Footer>
      </ResponsiveDesign.Desktop>
    </>
  )
}
